import { Link } from 'react-router-dom'

const QuotationCTA = () => {
  return (
    <section className="section-padding bg-gradient-to-br from-primary-green to-primary-green-dark text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="mb-6 text-white">Ready to Start Your Renewable Energy Journey?</h2>
          <p className="text-xl mb-8 text-green-100">
            Get a free, no-obligation quotation from our renewable energy experts. 
            We'll assess your home and provide a tailored solution that maximizes your savings and sustainability.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 lg:gap-20 mb-12">
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-4">
                <span className="text-2xl font-bold">1</span>
              </div>
              <h4 className="font-semibold mb-2">Free Consultation</h4>
              <p className="text-md text-green-100">
                Our experts assess your home's renewable energy potential
              </p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-4">
                <span className="text-2xl font-bold">2</span>
              </div>
              <h4 className="font-semibold mb-2">Home Assessment</h4>
              <p className="text-md text-green-100">
                We attend in-person to conduct an on-site assessment
              </p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-4">
                <span className="text-2xl font-bold">3</span>
              </div>
              <h4 className="font-semibold mb-2">Competitive Quotation</h4>
              <p className="text-md text-green-100">
                We apply relevant grants and competitive prices, to offer you the best bespoke offering
              </p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-4">
                <span className="text-2xl font-bold">4</span>
              </div>
              <h4 className="font-semibold mb-2">Professional Installation</h4>
              <p className="text-md text-green-100">
                Certified installers handle everything from permits to testing
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/quote"
              className="bg-white text-primary-green hover:bg-gray-100 font-medium px-8 py-4 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 text-lg"
            >
              Get Your Free Quote
            </Link>
            <a
              href={`tel:${import.meta.env.VITE_COMPANY_PHONE?.replace(/\s/g, '')}`}
              className="border-2 border-white text-white hover:bg-white hover:text-primary-green font-medium px-8 py-4 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 text-lg"
            >
              Call Now: {import.meta.env.VITE_COMPANY_PHONE}
            </a>
          </div>

          <div className="mt-8 flex flex-wrap justify-center items-center gap-6 text-sm text-green-100">
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>No obligation</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Free site survey</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Certified installers</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default QuotationCTA